import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import router from './router'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueClipboard from 'vue-clipboard2';
import VTooltip from 'v-tooltip';
import Toasted from 'vue-toasted';

Vue.component(VueQrcode.name, VueQrcode);
Vue.use(Vuelidate);
Vue.use(VueClipboard);
Vue.use(VTooltip);
Vue.use(Toasted, {
  position: 'bottom-center',
  action: {
    text: 'CLOSE',
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  },
  keepOnHover: true,
  className: 'error-snackbar',
  containerClass: 'wrapper-error-snackbar',
  singleton: true,
  duration: 10000,
  fullWidth: true
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
